module.exports = __webpack_public_path__ + "static/img/4.502e510.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/4.png
// module id = YHPr
// module chunks = 13